import { SCREEN_SHARE_REQUEST_STATUS } from '../constants';
import { SET_SCREEN_SHARE_REQUEST_STATUS } from '../actions/Types';

const initialState = {
  status: SCREEN_SHARE_REQUEST_STATUS.IDLE,
  sourceId: null // e.g., to store the screen source ID
};

/**
 * Reducer for tracking the lifecycle of a screen share request.
 * Especially tracking the sourceId associated with the request.
 *
 * This reducer listens for actions of type `SET_SCREEN_SHARE_REQUEST_STATUS`
 * and replaces the state with the provided payload. The payload is expected
 * to have the shape: `{ status: string, meta: Object|null }` where `status`
 * is one of the values defined in `SCREEN_SHARE_REQUEST_STATUS`.
 *
 * @param {Object} [state=initialState] - Current reducer state.
 * @param {Object} action - Redux action.
 * @param {string} action.type - Action type.
 * @param {{status: string, sourceId: string|null}} [action.payload] - Action payload.
 *
 * @returns {{status: string, sourceId: string|null}} New state object.
 */
const screenShareRequest = (state = initialState, action) => {
  if (action.type === SET_SCREEN_SHARE_REQUEST_STATUS) {
    const { status, sourceId = null } = action.payload;
    return { status, sourceId };
  }
  return state;
};

export default screenShareRequest;
